<template>
  <a-form-model class="form" :model="form" ref="editForm" :rules="rules">
    <a-form-model-item label="大标题">
      <a-input v-model="form.title" placeholder="文章列表大标题"></a-input>
    </a-form-model-item>
    <a-form-model-item label="文章列表">
      <drag-zone drag-zoneclass="item-list" :list="items">
        <template v-slot="{ item, index }">
          <div class="article-item">
            <div
              class="article-img"
              :style="{ backgroundImage: `url(${item.img}` }"
            ></div>
            <div class="article-info">
              <div class="article-title">{{ item.title }}</div>
              <div class="article-desc">{{ item.desc }}</div>
              <div class="article-detail">
                {{ item.type == 2 ? "外部链接" : "内部文章" }}
              </div>
            </div>
            <div class="article-btn">
              <a-icon
                type="form"
                class="icon-edit-outline"
                @click="editArticle(index)"
              />
              <a-icon
                type="delete"
                class="icon-delete"
                @click="remove(index)"
              />
            </div>
          </div>
        </template>
      </drag-zone>
      <div class="add-item" @click="addItem">
        <div class="add-icon"></div>
        <div class="add-txt">添加文章</div>
      </div>
    </a-form-model-item>
    <template v-if="form.more">
      <a-form-model-item label="卡片“更多”文字">
        <a-input v-model="form.more.title"></a-input>
      </a-form-model-item>
      <a-form-model-item label="卡片“更多”链接">
        <a-input v-model="form.more.url"></a-input>
      </a-form-model-item>
    </template>
    <a-form-model-item label="排版方式">
      <a-radio-group v-model="form.layout" default-value="horizontal" :options="[{label:'横版', value: 'horizontal'},{label:'竖版', value: 'vertical'}]"/>
    </a-form-model-item>
    <a-form-model-item label="标题加粗">
      <a-switch v-model="form.bold"></a-switch>
    </a-form-model-item>
    <!-- <a-form-model-item label="卡片分割线">
      <a-switch v-model="form.itemLine"></a-switch>
    </a-form-model-item> -->
    <a-form-model-item label="标题分割线">
      <a-switch v-model="form.topLine"></a-switch>
    </a-form-model-item>
    <a-form-model-item label="内层间距" v-if="form.padding">
      <a-space>
        <a-input
          type="number"
          class="inline-input"
          placeholder="上"
          v-model="form.padding.top"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="下"
          v-model="form.padding.bottom"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="左"
          v-model="form.padding.left"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="右"
          v-model="form.padding.right"
        ></a-input>
      </a-space>
    </a-form-model-item>
    <a-form-model-item label="外层间距" v-if="form.margin">
      <a-space>
        <a-input
          type="number"
          class="inline-input"
          placeholder="上"
          v-model="form.margin.top"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="下"
          v-model="form.margin.bottom"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="左"
          v-model="form.margin.left"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="右"
          v-model="form.margin.right"
        ></a-input>
      </a-space>
    </a-form-model-item>
    <a-form-model-item label="背景色">
      <colorPicker
        class="color-picker shadow"
        v-model="form.backgroundColor"
      ></colorPicker>
    </a-form-model-item>
    <template v-if="form.content">
      <a-form-model-item label="内容内层间距" v-if="form.content.padding">
        <a-space>
          <a-input
            type="number"
            class="inline-input"
            placeholder="上"
            v-model="form.content.padding.top"
          ></a-input>
          <a-input
            type="number"
            class="inline-input"
            placeholder="下"
            v-model="form.content.padding.bottom"
          ></a-input>
          <a-input
            type="number"
            class="inline-input"
            placeholder="左"
            v-model="form.content.padding.left"
          ></a-input>
          <a-input
            type="number"
            class="inline-input"
            placeholder="右"
            v-model="form.content.padding.right"
          ></a-input>
        </a-space>
      </a-form-model-item>
      <a-form-model-item label="内容圆角">
        <a-input type="number" v-model="form.content.borderRadius"></a-input>
      </a-form-model-item>
      <a-form-model-item label="内容背景色">
        <colorPicker
          class="color-picker top shadow"
          v-model="form.content.backgroundColor"
        ></colorPicker>
      </a-form-model-item>
    </template>
    <a-form-model-item label="是否在首页显示">
      <a-switch v-model="form.isShow"></a-switch>
    </a-form-model-item>
    <a-modal
      title="文章配置"
      width="300px"
      :visible.sync="ds"
      @ok="confirmArticle"
      @cancel="hideDialog"
    >
      <a-form-model
        ref="articleForm"
        :model="article"
        :rules="articleRules"
        v-if="article"
      >
        <a-form-model-item label="文章类型" prop="type">
          <a-radio-group v-model="article.type">
            <a-radio :value="1">内部文章</a-radio>
            <a-radio :value="2">外部链接</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          label="选择文章"
          v-if="article.type == 1"
          prop="detail"
        >
          <a-select
            v-model="article.detail"
            allowClear
            placeholder="输入文章标题搜索"
            show-search
            label-in-value
            :filter-option="false"
            :not-found-content="loading ? undefined : null"
            :default-active-first-option="false"
            @search="searchArticle"
            @change="articleChange"
          >
            <a-select-option v-for="item in articleList" :key="item.id">
              {{ item.title }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <template v-else-if="article.type == 2">
          <a-form-model-item label="文章链接" prop="link">
            <a-input v-model="article.link" placeholder="文章链接"></a-input>
          </a-form-model-item>
          <a-form-model-item label="文章标题" prop="title">
            <a-input v-model="article.title" placeholder="文章标题"></a-input>
          </a-form-model-item>
          <a-form-model-item label="文章摘要" prop="desc">
            <a-input v-model="article.desc" placeholder="文章摘要"></a-input>
          </a-form-model-item>
          <a-form-model-item label="文章缩略图" prop="img">
            <cl-upload v-model="article.img"></cl-upload>
          </a-form-model-item>
        </template>
      </a-form-model>
    </a-modal>
  </a-form-model>
</template>

<script>
/*
 * article 数据结构
 * 内部文章
 *   新{id: Number, title: Sting, desc:String, img: String, type: 1}
 *   旧{title: Sting, desc:String, img: String, type: 1, detail: Article}
 * 外部链接
 *   新{title: Sting, desc:String, img: String, link: String, type: 2}
 *   旧{title: Sting, desc:String, img: String, type: 2, detail: {link: String}}}
 * */
import clUpload from "../cl-upload";
import dragZone from "../drag-zone";
import { clone, randomString, debounce } from "../../common/js/tool";

export default {
  name: "article-edit",
  components: {
    dragZone,
    clUpload,
  },
  props: {
    value: Object,
  },
  inject: ["build"],
  data() {
    this.lastFetchId = 0;
    this.searchArticle = debounce(this.searchArticle, 500);
    return {
      form: {},
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
      },
      items: [],
      article: null,
      index: null,
      articleRules: {
        type: [
          { required: true, message: "请选择文章类型", trigger: "change" },
        ],
        detail: [{ required: true, message: "请选择文章", trigger: "change" }],
        link: [{ required: true, message: "请输入文字链接", trigger: "blur" }],
        title: [{ required: true, message: "请输入文章标题", trigger: "blur" }],
        img: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value && value.length > 0) {
                callback();
              } else {
                callback(new Error("请上传文章封面图"));
              }
            },
            trigger: "change",
          },
        ],
        desc: [{ required: true, message: "请输入文章摘要", trigger: "blur" }],
      },
      articleList: [],
      loading: false,
    };
  },
  computed: {
    ds: {
      get() {
        return !!this.article;
      },
      set(val) {
        !val && this.hideDialog();
      },
    },
    activity() {
      return this.$store.getters.activity;
    },
    id() {
      return this.$route.params.id;
    },
  },
  watch: {
    form: {
      handler() {
        this.update();
      },
      deep: true,
    },
    items: {
      handler() {
        this.update();
      },
      deep: true,
    },
    value() {
      this.setValue();
    },
  },
  created() {
    this.setValue();
  },
  methods: {
    searchArticle(val) {
      if (val !== "") {
        this.lastFetchId += 1;
        const fetchId = this.lastFetchId;
        this.articleList = [];

        this.loading = true;
        let url = `/activity/activity-article?filter[activity_id]=${this.id}&filter[title][like]=${val}`;
        let build = this.build;
        if (build.isActivity && build.conf) {
          url += `&filter[activity_id]=${build.conf.id}`;
        }
        this.$axios(url)
          .then((res) => {
            if (fetchId !== this.lastFetchId) {
              // for fetch callback order
              return;
            }

            this.articleList = res.data;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
            this.articleList = [];
          });
      } else {
        this.articleList = [];
      }
    },
    articleChange(value) {
      if (this.article.detail) {
        this.article.detail.info = this.articleList.find(
          (item) => item.id == value.key
        );
      }

      this.articleList = [];
      this.loading = false;
      this.searchArticle(value);
    },
    confirmArticle() {
      this.$refs.articleForm.validate((flag) => {
        if (flag) {
          let article = this.article;
          let item;
          if (article.type == 1) {
            let { id, title, desc, img } = article.detail.info;
            let type = article.type;
            item = { id, title, desc, img, type };
          } else {
            item = {
              title: article.title,
              desc: article.desc,
              type: article.type,
              img: article.img,
              link: article.link,
            };
          }
          //编辑
          let items = this.items;
          if (article.key) {
            item.key = article.key;
            this.$set(items, this.index, item);
          } else {
            // 新增
            item.key = `article_${randomString(6)}`;
            items.push(item);
          }
          this.hideDialog();
        }
      });
    },
    hideDialog() {
      this.article = null;
      this.index = null;
    },
    setValue() {
      if (this.value) {
        let temp = clone(this.value);
        let list = temp.list;
        this.getArticleInfo(list);
        this.items = list;
        delete temp.list;
        this.form = temp;
      }
    },
    getArticleInfo(list) {
      //处理成统一的数据结构 并实时获取内部文章信息
      let ids = [];
      list.forEach((item) => {
        if (item.type == 1) {
          //新的数据结构
          if (item.id) {
            ids.push(item.id);
          } else {
            let detail = item.detail;
            ids.push(detail.id);
            item.id = detail.id;
            detail.title && (item.title = detail.title);
            detail.desc && (item.desc = detail.desc);
            detail.img && (item.img = detail.img);
          }
        } else {
          if (!item.link) {
            item.link = item.detail ? item.detail.link : null;
          }
        }
        delete item.detail;
      });
      if (ids.length > 0) {
        this.$axios({
          url: "/activity/activity-article/list",
          params: {
            ids: ids.join(","),
          },
          loadingText: false,
        }).then((res) => {
          let items = this.items;
          res.forEach((a) => {
            let index = items.findIndex((t) => t.id == a.id);
            if (index >= 0) {
              let item = items[index];
              item.title = a.title;
              item.desc = a.desc;
              item.img = a.img;
              this.$set(items, index, item);
            }
          });
        });
      }
    },
    editArticle(index) {
      let item = this.items[index];
      let article = clone(item);
      if (article.type == 1) {
        article.detail = {
          key: article.id,
          label: article.title,
          info: clone(article),
        };
        this.articleList = [article];
      }
      this.article = article;
      this.index = index;
    },
    addItem() {
      this.article = { type: 1 };
    },
    remove(i) {
      this.items.splice(i, 1);
    },
    update() {
      let temp = clone(this.form);
      temp.list = clone(this.items);
      this.$emit("change", temp);
    },
    validate() {
      let msg = null;
      let items = this.items;
      if (items.length <= 0) {
        msg = "请至少添加一篇文章";
      }
      // if (!this.form.title) {
      //   msg = "请输入文章列表大标题";
      // }
      return msg;
    },
  },
};
</script>

<style scoped lang="less">
.form {
  --back-light-color: #eee;
  --back-white-color: #fff;
  --text-font-color: #606266;
  --tip-font-color: #909399;
}
.article-item {
  display: flex;
  position: relative;
  padding: 10px;
  background-color: var(--back-light-color);
  border-bottom: 1px solid var(--back-white-color);
  &:hover {
    .article-btn {
      display: flex;
    }
  }
}
.article-img {
  flex-shrink: 0;
  width: 80px;
  height: 80px;
  background: center no-repeat;
  background-size: cover;
}
.article-info {
  flex: 1;
  margin: 0 5px;
  line-height: 1;
}
.article-desc {
  margin-top: 12px;
  color: var(--tip-font-color);
}

.article-detail {
  margin-top: 6px;
  font-size: 12px;
  color: var(--text-font-color);
}
.article-btn {
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  padding: 0 10px;
  width: 40px;
  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 0.5),
    rgba(255, 255, 255, 0.8)
  );
  font-size: 20px;
  color: var(--text-font-color);
  cursor: pointer;
  .icon-delete {
    margin-top: 10px;
  }
}

.color-picker::v-deep {
  .colorBtn {
    width: 20px;
    height: 20px;
  }
}
</style>
